import { TableDataStatus } from "./TypesEnums.";

 export const tableDataStatusDefault: TableDataStatus= {
    filterWord: '',
    dataFiltered: [],
    selectedRow: {}
  }